function extractAltContent(el: HTMLElement) {
  const labelledBy = el.getAttribute('aria-labelledby') ?? '';
  if (labelledBy.length > 0) {
    const label = labelledBy
      .split(' ')
      .map((id) => document.getElementById(id)?.innerText ?? '')
      .filter((txt) => txt.length > 0)
      .join(' ')
      .trim();
    if (label.length > 0) return label;
  }

  const label = el.getAttribute('aria-label')?.trim() ?? '';
  if (label.length > 0) return label;

  if (el.id.length > 0) {
    const label = Array.from(document.querySelectorAll(`label[for="${el.id}"]`))
      .map((_el) => (_el as HTMLElement).innerText as string)
      .filter((txt) => txt.length > 0)
      .join(' ')
      .trim();
    if (label.length > 0) return label;
  }

  const alt = el.getAttribute('alt')?.trim() ?? '';
  if (alt.length > 0) return alt;

  return '';
}

/**
 * Helper function that returns the textual content of elements (similar to `element.textContent` and `element.innerText`),
 *
 * If the given element contains no text, this function will fallback to traversing
 * the children of the provided element, collecting text from `aria-label`, `aria-labelledby`,
 * `alt` text, and `<label for="[id]">`.
 */
export function domExtractTextContent(element: HTMLElement) {
  const explicit = element.innerText.trim();

  if (element.tagName.toLowerCase() === 'select' && explicit.length > 0) {
    const el = element as HTMLSelectElement;
    const v = (
      el.querySelector(`option[value="${el.value}"]`) as HTMLElement | null
    )?.innerText;
    if (v != null && v.length > 0) return v;
  }

  if (explicit.length > 0) return explicit;

  const explicitAlt = extractAltContent(element).trim();
  if (explicitAlt.length > 0) return explicitAlt;

  const implicit = (
    Array.from(
      element.querySelectorAll('[aria-label],[aria-labelledby],[alt],[id]')
    ) as HTMLElement[]
  )
    .map(extractAltContent)
    .filter((txt) => txt.length > 0)
    .join(' ')
    .trim();

  return implicit.length > 0 ? implicit : null;
}
